import { match } from 'ts-pattern'

import GeneratorLyricsSmart from '../../components/GeneratorLyricsSmart'
import AiThinking from '../../components/AiThinking'
import AiLyrice from '../../components/AiLyrice'
import MusicStyle from '../../components/MusicStyle'

import type { FormInstance } from 'antd'
import type { MusicGeneratorFormValuesNew } from '@/pages/tad.ai/ai-music-generator/_types/form'

import Ideas from '@/pages/tad.ai/ai-music-generator/_components/Ideas'
import CreateButton from '@/pages/tad.ai/_components/CreateButton'
import StickyFormActionLayout from '@/pages/tad.ai/_components/StickyFormActionLayout'
import { useAiMusicGeneratorStoreFromZustand } from '@/pages/tad.ai/ai-music-generator/_store/createStore'


import { cls } from 'tagged-classnames-free';
export interface SmartFormProps {
  className?: string
  form: FormInstance<MusicGeneratorFormValuesNew>
  generateMusicLoading: boolean
}

const SmartForm = (props: SmartFormProps) => {
  const { className, form, generateMusicLoading } = props
  const {
    lyricsTextareaContent,
    aiIdeasAreaShow,
    aiThinkingAreaShow,
    aiLyriceAreaShow,
    styleShow,
    updatelyricsTextareaContent,
    isStream,
  } = useAiMusicGeneratorStoreFromZustand()
  const aiCreateBtnShow = useAiMusicGeneratorStoreFromZustand(
    (state) => state.aiCreateBtnShow,
  )

  const handleChange = (value: string) => {
    updatelyricsTextareaContent(value)
  }

  return (
    <StickyFormActionLayout
      className={cls`relative w-full ${className}`}
      contentClassName={cls`px-4 md:px-6 ${!aiCreateBtnShow ? 'pb-0' : ''}`}
      action={
        <CreateButton disabled={isStream} loading={generateMusicLoading} />
      }
      actionClassName={cls`px-4 md:px-6 ${!aiCreateBtnShow ? 'hidden' : ''}`}
    >
      <div>
        <GeneratorLyricsSmart form={form} />
        {match(aiIdeasAreaShow)
          .with(true, () => (
            <div className='mb-5'>
              <Ideas form={form} tagClassName='flex-col !bg-f-bg-elevated' />
            </div>
          ))
          .otherwise(() => null)}
        {match(aiThinkingAreaShow)
          .with(true, () => <AiThinking />)
          .otherwise(() => null)}
        {match(aiLyriceAreaShow)
          .with(true, () => (
            <AiLyrice
              lyrics={lyricsTextareaContent}
              form={form}
              onChangeLyrics={handleChange}
            />
          ))
          .otherwise(() => null)}
        {styleShow && <MusicStyle form={form} />}
      </div>
    </StickyFormActionLayout>
  )
}

export default SmartForm
